import React, { useEffect } from "react";
import InformationCard from "../InformationCard";
import { useDispatch, useSelector } from "react-redux";
import { getNewsList } from "../../../actions/crawlingAction";
import { timeForToday } from "../../../util/timeForToday";
import { InfomationWrapper, InfomationList } from "./index.style.js";

const InformationContainer = () => {
  const dispatch = useDispatch();

  const { newsList } = useSelector(state => state?.crawlingNews);

  useEffect(() => {
    dispatch(getNewsList());
  }, [dispatch]);

  return (
    <InfomationWrapper>
      <InfomationList>
        {newsList &&
          newsList.map((newsItem, index) => {
            return (
              <InformationCard
                key={index}
                image={newsItem?.thumbnail}
                title={newsItem?.title.replace("<b>", "").replace("</b>", "")}
                date={timeForToday(newsItem?.datetime)}
                category="블로그"
                content={newsItem?.contents.replace(/(<([^>]+)>)/gi, "")}
                link={newsItem?.url}
              />
            );
          })}
      </InfomationList>
    </InfomationWrapper>
  );
};

export default InformationContainer;
